module.exports = __webpack_public_path__ + "static/media/logo-with-circle.dca95380.svg";